<template>
  <div>
	<navbar :hasSearch="true" />
	<div id="content">
	<div class="row">
	<div class="col-md-6 pb-3">
		<div class="card h-100">
		<ol class="breadcrumb lighten-4 my-auto">
			<li class="breadcrumb-item">
			<router-link :to="{ name: 'landingPage' }">
				<a class="black-text" href="#">Home</a>
			</router-link>
			<i class="fa fa-angle-right mx-2" aria-hidden="true"></i>
			</li>
			<li class="breadcrumb-item">
			<router-link :to="{ name: 'ddFailureCharges' }">
				<a class="black-text" href="#">DD Payment Failure Charges</a>
			</router-link>
			<i class="fa fa-angle-right mx-2" aria-hidden="true"></i>
			</li>
			<li class="breadcrumb-item active font-weight-bold">
			Edit Charge
			<i class="fa fa-angle-right mx-2" aria-hidden="true"></i>
			</li>
		</ol>
		</div>
	</div>
	<quick-links></quick-links>
	</div>

	<div class="row">
	<div class="col-md-8">
		<div class="card border border-light rounded p-3">
			<div class="row mt-3 mb-3">
			<div class="col-12">
				<h4 class="d-inline">Edit Failed Payment Charge</h4>
			</div>
			</div>
			<form @submit.prevent="saveCharge">
			<!-- Charge Code/Type Section -->
			<div class="form-group row align-items-center my-2">
				<div class="col-sm-4">
				<label for="charge-code">Charge Code:</label>
				</div>
			<div class="col-sm-8">
				<!-- Dropdown for selection -->
				<b-form-select id="charge-code" class="form-control mb-3" v-model="charge.Code" :disabled="true">
				<option v-for="aruddCode in aruddCodes" :key="aruddCode.Code" :value="aruddCode.Code">
					{{ aruddCode.Description }} ({{aruddCode.Code}})
				</option>
				</b-form-select>
			</div>
			</div>
			
			<div class="form-group row align-items-center my-2">
				<div class="col-sm-4">
				<label for="amount">Amount:</label>
				</div>
				<div class="col-sm-8">
				<div class="input-group">
					<div class="input-group-prepend">
					<span class="input-group-text">£</span>
					</div>
					<input id="amount" type="number" class="form-control" v-model.number="charge.Amount" />
				</div>
				</div>
			</div>
			<div class="form-group row align-items-center my-2">
				<div class="col-sm-4">
				<label for="enabled">Enabled:</label>
				</div>
				<div class="col-sm-8">
				<b-form-checkbox id="enabled" v-model="charge.Enabled">Enabled</b-form-checkbox>
				</div>
			</div>
			<div class="row mt-3">
				<div class="col-12 text-right">
				<button type="submit" class="btn btn-success mr-2">Save</button>
				<router-link :to="{ name: 'ddFailureCharges' }" class="btn btn-danger">Cancel</router-link>
				</div>
			</div>
			</form>
		</div>
		</div>
	</div>
	</div>
</div>
  
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import QuickLinks from '@/components/QuickLinks.vue';

export default {
	name: 'EditFailedDdPaymentCharge',
	components: {
		Navbar,
		QuickLinks,
	},
	data() {
		return {
			charge: {
				Code: null,
				Description: null,
				Amount: 0,
				Enabled: false,
			},
			componentLoading: false,
		};
	},
	computed: {
		aruddCodes() {
			return this.$store.state.finances.aruddCodes;
		},
		ddCharges() {
			return this.$store.state.finances.ddCharges;
		},
	},
	methods: {
		async fetchAndInitializeCharge() {
			this.componentLoading = true;
			const aruddCode = this.$route.params.id;

			// Ensure aruddCodes are loaded
			if (this.aruddCodes.length === 0) {
				await this.$store.dispatch('getAruddCodes');
			}

			// Ensure ddCharges are loaded
			if (this.ddCharges.length === 0) {
				await this.$store.dispatch('getDdCharges');
			}

			const existingCharge = this.ddCharges.find((c) => c.Code === aruddCode);
			if (existingCharge) {
				this.charge = {
					Code: existingCharge.Code,
					Description: existingCharge.Description,
					Amount: existingCharge.Amount || 0,
					Enabled: existingCharge.Enabled || false,
				};
			} else {
				const baseAruddCode = this.aruddCodes.find((c) => c.Code === aruddCode);
				if (baseAruddCode) {
					this.charge = {
						Code: baseAruddCode.Code,
						Description: baseAruddCode.Description,
						Amount: 0,
						Enabled: false,
					};
				} else {
					// Handle invalid URL parameter - redirect or show error
					this.$snotify.error('Invalid ARUDD Code provided.');
					this.$router.push({ name: 'ddFailureCharges' });
				}
			}
			this.componentLoading = false;
		},
		saveCharge() {
			this.$store
				.dispatch('updateDdCharge', this.charge)
				.then(() => {
					this.$snotify.success('Charge saved successfully!');
					this.$router.push({ name: 'ddFailureCharges' });
				})
				.catch(() => {
					this.$snotify.error('Error saving charge.');
				});
		},
	},
	async created() {
		await this.fetchAndInitializeCharge();
	},
};
</script>
